module.exports = __webpack_public_path__ + "Roboto-BlackItalic.3a99796b2d8592471fcf.woff";


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/roboto-fontface/fonts/Roboto/Roboto-BlackItalic.woff
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-BlackItalic.woff
// module chunks = 34